// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainWrapper_wrapper__ZjqMi"};